
import React, { useState, useEffect } from 'react';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';
import { 
  Container, 
  Tab, 
  Tabs,
  Pagination,
  Typography,
  useMediaQuery,
  Button,
  Grid,
  Modal,
  TextField,
  TableContainer,
  Paper,
  TablePagination,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ListItem,
  ListItemText,
  List,
  Autocomplete,
  Box,
  Alert } from '@mui/material';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
  import { DatePicker } from '@mui/x-date-pickers/DatePicker';
  import { DateCalendar } from '@mui/x-date-pickers';
  import { PickersDay } from '@mui/x-date-pickers';
  import styles from './Depository.module.css';
  import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
  import AppConfig from '../AppConfig';
  import ApiClient from '../utilities/apiClient';
  import { useAppData } from '../redux/appDataProvider';
  import { useSelector } from 'react-redux';
  import dayjs from 'dayjs';
  import MyModal from "../components/session_expired"
  import MyLodder from '../components/lodder';
  import xlsexport from 'xlsexport'
  import exportFromJSON from 'export-from-json';
import { color } from 'd3';
  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  // Empty dependency array to fetch data only once on component mount
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  };

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const columns = [
    { id: 'SCRIP_SERIES', label: 'Symbol' },
    { id: 'TRADE_DATE', label: 'Trade time' },
    { id: 'ORDER_NUMBER', label: 'Order ID' },
    { id: 'TRADE_NUMBER', label: 'Trade ID' },
    { id: 'TRADE_TYPE', label: 'Type' },
    { id: 'COMPANY_CODE', label: 'Segment' },
    { id: 'QUANTITY', label: 'Qty' }, 
    { id: 'PRICE', label: 'Price' }, 
    
  ];
  // List order changed - 19-07-24 -Dev Srini
  const options = [
    { label: 'Equity', id: 'Equity' },
    { label: 'Derivative', id: 'Derivative' },
    { label: 'All', id: 'All' },
  ]
  
  const TradeCalendar = styled(DateCalendar)(({ theme }) => ({
    backgroundColor: "transparent !important",
    "& .MuiPickersArrowSwitcher-root" : {
      display : "none !important"
    },
    "& .MuiDayCalendar-weekDayLabel":{
      color: "#67b5ed !important",
      backgroundColor: "#131E2E !important",
      height: "20px !important",
      width: "20% !important",
      fontSize : "10px !important",
    },
    "& .MuiPickersCalendarHeader-root" :{
      paddingLeft: "0px !important",
      width: "100% !important"
    },
    "& .MuiPickersCalendarHeader-label" : {
      fontSize : "13px !important"
    },
    "& .MuiPickersDay-dayOutsideMonth" : {
      color : "#2F465F !important"
    }
  }));

  const customScrollbarStyles = {
    background : "#0B1420",
    width : "100%",
    marginTop : "20px",
    scrollbarWidth : "thin",
    scrollbarColor: 'rgba(170,170,170,0.4) transparent', 
  };

  const HighlightedDay = styled(PickersDay)(({ theme }) => ({
    color : "#426F8F !important",
    backgroundColor: "#131E2E !important",
    borderRadius: "0px !important",
    height: "20px !important",
    width: "20% !important",
    fontSize : "10px !important",
    "&.Mui-selected": {
      backgroundColor: "#15437F !important",
      color: "#FFFFFF !important",
      fontSize : "10px" 
    }
  }));

  const ServerDay = (props) => {
    const { highlightedDays = [], day, outsideCurrentMonth, ...other } = props;
  
    const isSelected =
      !props.outsideCurrentMonth &&
      highlightedDays.includes(day.format("YYYY-MM-DD")) || props.outsideCurrentMonth &&
      highlightedDays.includes(day.format("YYYY-MM-DD"))
  
    return (
      <HighlightedDay
        {...other}
        outsideCurrentMonth={outsideCurrentMonth}
        day={day}
        selected={isSelected}
      />
    )
  };


const Tradebook = (
  

) => {
  const [value, setValue] = React.useState(0);
  const [data , setData] = React.useState([]) 
  const [dpdata, setDpdata] = React.useState([]);
   // Initial value changed All to Equity - 19-07-24 -Dev Srini
  const [tradetype, setTradeType] = React.useState('Equity');
  const { userInfo, setUserInfo } = useAppData();
  const {selectedYear,setSelectedYear} = useAppData()
  const [fdate,SetFDate]= React.useState(dayjs(new Date()).subtract("3","month"));
  const [tdate,SetTDate]= React.useState(dayjs(new Date())) 
  const apiToken = useSelector(state => state.auth.apiToken);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const screen800px = useMediaQuery("(max-width : 800px)")
  const screen900px = useMediaQuery("(max-width : 900px)")
  const [showmodal, setShowModal] = React.useState(false);
  const [showlodder, setShowLodder] = React.useState(false);
  const [handleDate,sethandleDate] = React.useState(false) 
  const [date,setDate] = React.useState(dayjs().subtract(3,"month"))
  const [highlightedDays, setHighlitedDays] = useState([])
  const [page, setPage] = useState(0);
  const [mpage, setMPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [mdata,setMdata] = useState([]) 
  const [error ,setError] = useState(false) 


  useEffect(()=>{
    const newArr = data && data.slice((mpage - 1)*5 ,(mpage)*5)
  
    setMdata(newArr)
  },[mpage,data])

  const  handlePageChange = (event, newpage) => { 
    setPage(newpage); 
  }

  const  handleMPageChange = (event, newpage) => { 
    setMPage(newpage); 
  }

  const handleRowsPerPageChange =(event) => { 
    setRowsPerPage(+event.target.value); 
    setPage(0); 
  } 

  useEffect(()=>{
    const trades = data.map(trade =>{
      return trade.TRADE_DATE.slice(0,10)
    })
    setHighlitedDays(trades) 
  },[dpdata])

  const Export_TradeBook=(data)=> {
    const fileName = "TradeBook"
    const exportType = exportFromJSON.types.csv
    exportFromJSON({data,fileName,exportType})

}
  useEffect(() => {
    window.scrollTo(0, 0)
    
    if(localStorage.getItem("year") == new Date().getFullYear()){
      SetFDate(dayjs(new Date()).subtract("3","month"))
      SetTDate(dayjs(new Date()))
    }else{
      SetFDate(dayjs(new Date(`04/01/${selectedYear.Database_Year}`)))
      SetTDate( dayjs(new Date(`03/31/${parseInt(selectedYear.Database_Year) + 1}`)))
    }
    
    if(selectedYear.Database_Year){
      sethandleDate(!handleDate)
    }

    }, [selectedYear]);

    useEffect(()=>{
          handleSubmit()
    },[handleDate]) 

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  const handleSegment = (event, newValue) => {
     // removed console - 19-07-24 -Dev Srini
    setTradeType(newValue.id)
  };

  const handleSelectedDate = (newValue) =>{
    setDate(newValue)
    const trades = data.filter(trade =>{
      return trade.TRADE_DATE.slice(0,10) === dayjs(newValue).format("YYYY-MM-DD")
    })
    setDpdata(trades)
  }
  
  const  handleSubmit=()=>{
    if(tdate < fdate){
      return setError(true)
    }
    try {
       // resting pagination values - 19-07-24 -Dev Srini
      setPage(0)
      setMPage(1)
      setError(false)
      setShowLodder(true)
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
      console.log("start")
      const apiClient = new ApiClient(apiToken);
      
//       {
//     "from_date": "01/10/2025",
//     "BRANCH_CODE": "",
//     "Client_code": "4012",
//     "to_date": "10/10/2025",
//     "Scrip_Symbol": "",
//     "Company_Code": "",
//     "MKT_TYPE": ""
// }
      if( tradetype!=="All")
      {apiClient.fetchData(
        AppConfig.api.Tradebook.book,
        "POST",
        {
          "from_date": fdate.format('DD/MM/YYYY'),
          "to_date": tdate.format('DD/MM/YYYY'),
          "Client_code": localStorage.getItem('userid'),//userInfo.CLIENT_ID,
          "BRANCH_CODE": "",
          "Scrip_Symbol": "",
          // "Company_Code": "",
          "MKT_TYPE": "",
          "Company_Code":tradetype == "Equity" && "nse_cash,BSE_CASH" || tradetype == "Derivative" && "NSE_FNO" ,
         
          
        })
        .then((response) => {
          console.info(response);
          setShowLodder(false)
          if(response===401){setShowModal(true)}

          if(response && response.Success == "False" && response.hasOwnProperty("Error Description"))
            {
              setDpdata([])
              setData([])
            }
          if(response && response.Success == "True" && response.hasOwnProperty("Success Description")){
            let responseData = response["Success Description"]; 
            console.info(`data ${responseData}`);

            let re=responseData.map(data => {
              return {
                ISIN: data.ISIN,

                SCRIP_SERIES:data.SCRIP_SERIES,
                TRADE_DATE: data.TRADE_DATE.substring(0, 11)+" "+data.TRADE_TIME,
                ORDER_NUMBER:data.ORDER_NUMBER,
                TRADE_NUMBER:data.TRADE_NUMBER,
                TRADE_TYPE:data.BUY_QUANTITY>0 ? "BUY":"SELL",
                QUANTITY:data.BUY_QUANTITY>0? data.BUY_QUANTITY:data.SELL_QUANTITY,
                PRICE:data.BUY_PRICE>0? data.BUY_PRICE:data.SELL_PRICE,
                COMPANY_CODE:data.COMPANY_CODE==="NSE_CASH" || "BSE_CASH"? "CASH":"F&O"
              }


            })
             // LSorting latest vlaues - 19-07-24 -Dev Srini
            const sortedRe = re.sort((a, b) => {
              const dateTimeA = new Date(a.TRADE_DATE);
              const dateTimeB = new Date(b.TRADE_DATE);
              return dateTimeB - dateTimeA; // Sort from latest to oldest
            });

            // Updating state variables with sorted data
            setDpdata(sortedRe);
            setData(sortedRe);

          }
        })
        .catch((error) => {
          console.log(error);
        });
      }
      if( tradetype==="All")
      {apiClient.fetchData(
        AppConfig.api.Tradebook.book,
        "POST",
        {
        
          "Client_code": localStorage.getItem('userid'),//userInfo.CLIENT_ID,
          "from_date":fdate.format('DD/MM/YYYY'),
          "to_date":tdate.format('DD/MM/YYYY'),
         
          
        })
        .then((response) => {
          console.info(response);
          setShowLodder(false)
          if(response===401){setShowModal(true)}

          if(response && response.Success == "False" && response.hasOwnProperty("Error Description"))
            {
              setDpdata([])
              setData([])
            }
          if(response && response.Success == "True" && response.hasOwnProperty("Success Description")){
            let responseData = response["Success Description"]; 
            console.info(`data ${responseData}`);

            let re=responseData.map(data => {
              return {
                ISIN: data.ISIN,
                SCRIP_SERIES:data.SCRIP_SERIES,
                TRADE_DATE: data.TRADE_DATE.substring(0, 11)+" "+data.TRADE_TIME,
                ORDER_NUMBER:data.ORDER_NUMBER,
                TRADE_NUMBER:data.TRADE_NUMBER,
                TRADE_TYPE:data.BUY_QUANTITY>0 ? "BUY":"SELL",
                QUANTITY:data.BUY_QUANTITY>0? data.BUY_QUANTITY:data.SELL_QUANTITY,
                PRICE:data.BUY_PRICE>0? data.BUY_PRICE:data.SELL_PRICE,
                COMPANY_CODE:data.COMPANY_CODE==="NSE_CASH" ? "CASH":"F&O"
              }


            })

             // Sorting latest dates - 19-07-24 -Dev Srini
            const sortedRe = re.sort((a, b) => {
              const dateTimeA = new Date(a.TRADE_DATE);
              const dateTimeB = new Date(b.TRADE_DATE);
              return dateTimeB - dateTimeA; // Sort from latest to oldest
            });

            // Updating state variables with sorted data
            setDpdata(sortedRe);
            setData(sortedRe);

          }
        })
        .catch((error) => {
          console.log(error);
        });
      }
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }

  }
  return (
    <Container style={{padding:'3% 1%' , background :isSmallScreen ? "#241E41" : "#241E41" , minHeight : "100vh"}} >
     
      {
        isSmallScreen ? <>
        <Grid container rowSpacing={3} columnSpacing={1} item xs={12} sx={{background : "#241E41"}}>
        
          <Typography sx={{margin : "15px 0px 0px 20px" , fontSize : "25px"}}>
            Trade Book
          </Typography>
          <Autocomplete
      disablePortal
      disableClearable
    

      id="combo-box-demo"
      options={options}
      size='small'
      value={tradetype}
      onChange={handleSegment}
      sx={{ "& .MuiInputBase-root": { height: 40 },"& .MuiOutlinedInput-notchedOutline": { border: "none" } , height : "40px !important" , margin : "20px 15px 0px 20px" , width : "100%" }}
      renderInput={(params) => <TextField {...params} label="Segment" sx={{background : "#131E2E"}} />}
    />
    <Grid display="flex" justifyContent="space-between" margin = "15px 10px 0px 20px" width="100%">

    <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                >
                    <DatePicker 
                        label="From Date"
                        size="small"
                        format="DD/MM/YYYY"
                        disableFuture
                        value={fdate}
                        onChange={(newValue) => SetFDate(newValue)}
                        
                        sx={{ "& .MuiInputBase-root": { height: 40, display: "flex", alignItems: "center" }, backgroundColor: "#131E2E", marginRight: 1 ,
                        "& .MuiOutlinedInput-notchedOutline": { border: "none"} , width : "100%"}}
                        
                    />
                </LocalizationProvider>

                <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                >
                    <DatePicker 
                        label="To Date"
                        size="small"
                        disableFuture
                        format="DD/MM/YYYY"
                        value={tdate}
                        
                        onChange={(newValue) => SetTDate(newValue)}
                      fullWidth
                        sx={{ "& .MuiInputBase-root": { height: 40, display: "flex", alignItems: "center" }, backgroundColor: "#131E2E", marginRight: 1, "& .MuiOutlinedInput-notchedOutline": { border: "none" }, width : "100%"}}
                      
                    />
                </LocalizationProvider> 
    </Grid>
    { error && <Typography sx={{color : "red", marginLeft : "20px" , marginTop : "10px"}}>To Date should be greater than From Date </Typography>}
        {/* Changed to onTouch event - 23-07-24 - Dev Srini */}
          <Button 
              variant="contained" 
              size="large" 
              className={styles.mainbutton}
              fullWidth
              onTouchStart={() => handleSubmit()}
              sx={{height : "40px" , margin : "15px 20px 0px 20px"}}  
          >Submit</Button> 
        </Grid>
        {/*   Added download button - 19-07-24 -Dev Srini */}
        <Grid
          container
          sx={{
            margin: "3%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item>
            {/* Changed to onTouch event - 23-07-24 - Dev Srini */}
            <Button 
              variant="outlined"  
              size="large" 
              className={styles.outlinedButton}
              onTouchStart={() => Export_TradeBook(dpdata)} 
              sx={{ textWrap: "nowrap" }}
            >
              Download CSV
            </Button>
          </Grid>
        </Grid>

        {data.length === 0 ?  
        <Grid style={{display:'flex',justifyContent:'center', marginTop : "50px"}}> 
          <Alert severity="warning" style={{background:'transparent'}}>No Transactions found !</Alert>  
        </Grid> : 
        <List sx = {{ background: "#0B1420", margin: "20px 15px 0px 15px", borderRadius: "10px" }}>
          {mdata.map((item, index)=>{
            return(
          <ListItem key={index} sx = {{display : "flex" , flexDirection : "column" , alignItems : "start" ,borderBottom : "1.5px solid #000000"}}>
             <ListItemText
                  primary = {item.SCRIP_SERIES}
                  />
                  <ListItemText
                  sx={{width : "100%"}}
                  primary = {
                    <Box display="flex" >
                      <Grid width="40%">
                      <Typography className={styles.listPrimaryText}>Date</Typography>
                      </Grid>
                      <Grid width="40%" > 
                      <Typography className={styles.listPrimaryText} >Trade Id</Typography>
                      </Grid>
                      <Grid width="20%" > 
                      <Typography className={styles.listPrimaryText}>QTY</Typography>
                      </Grid>
                    </Box>
                  }
                  secondary = {
                    <Box display="flex">
                      <Grid width="40%">
                    <Typography marginRight= "15px" className={styles.listSecondaryText}>
                      {dayjs(item.TRADE_DATE.slice(0,10)).format("DD/MM/YYYY")}
                      </Typography>
                      </Grid>
                      <Grid width="40%" >
                    <Typography className={styles.listSecondaryText} >
                      {item.TRADE_NUMBER}
                      </Typography>
                      </Grid>
                      <Grid width="20%" >
                    <Typography className={styles.listSecondaryText}>
                    {item.QUANTITY}
                    </Typography>
                      </Grid>
                      
                    </Box>
                  }
                />
                 <ListItemText
                  sx={{width : "100%"}}
                  primary = {
                    <Box display="flex" >
                      <Grid width="40%">
                      <Typography className={styles.listPrimaryText}>Order Id</Typography>
                      </Grid>
                      <Grid width="40%" > 
                      <Typography className={styles.listPrimaryText} >Price</Typography>
                      </Grid>
                      <Grid width="20%" > 
                      <Typography className={styles.listPrimaryText}>Type</Typography>
                      </Grid>
                    </Box>
                  }
                  secondary = {
                    <Box display="flex">
                      <Grid width="40%">
                    <Typography marginRight= "15px" className={styles.listSecondaryText}
                    sx ={{wordWrap : "break-word" , width : "80%"}} 
                    >
                      {item.ORDER_NUMBER}
                      </Typography>
                      </Grid>
                      <Grid width="40%" >
                    <Typography className={styles.listSecondaryText}>
                      {parseFloat(item.PRICE).toFixed(2)}
                      </Typography>
                      </Grid>
                      <Grid width="20%" >
                        <Typography className={styles.listSecondaryText} sx={{ color : item.TRADE_TYPE == "BUY" ? "#7DAB1C !important" : "#F74542 !important" }} >{item.TRADE_TYPE}</Typography>
                      </Grid>
                    </Box> 
                  }
                />
          </ListItem>
            ) 
          })}
        <Grid sx={{display : "flex",justifyContent : "center", marginTop : "5px"}}>
            <Pagination showFirstButton showLastButton count={Math.ceil(data.length / 5)} size="small" page={mpage} 
              onChange={handleMPageChange} />
            </Grid>
        </List> }
      </> : <>
      <Typography >Tradebook</Typography>
      <Grid container style={{marginTop:'1%'}}   >
        
        <Grid style={{display:'flex',width:'100%',display:'flex',justifyContent:'space-evenly'}}>
            <Grid width={ screen800px ?  "20%" : "20%"} marginRight = "10px"> 
              <Autocomplete
                disablePortal
                disableClearable
                // freeSolo
                id="combo-box-demo"
                options={options}
                size='small'
                value={tradetype}
                onChange={handleSegment}
                fullWidth
                sx={{ "& .MuiInputBase-root": { height: 40 },"& .MuiOutlinedInput-notchedOutline": { border: "none" } , height : "40px !important" }}
                renderInput={(params) => <TextField {...params} label="Segment" sx={{background : "#131E2E"}} />}
              />
            </Grid>
          
            <Grid width={ screen900px ? screen800px ? "29%" : "25%" : "20%"}> 
                <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                >
                    <DatePicker 
                        label="From Date"
                        size="small"
                        format="DD/MM/YYYY"
                        disableFuture
                        value={fdate}
                        onChange={(newValue) => SetFDate(newValue)}
                        sx={{ "& .MuiInputBase-root": { height: 40, display: "flex", alignItems: "center" }, backgroundColor: "#131E2E", marginRight: 1 ,
                        "& .MuiOutlinedInput-notchedOutline": { border: "none"
                      }}}
                        fullWidth
                    />
                </LocalizationProvider>
            </Grid>
            <Grid width={ screen900px ? screen800px ? "29%" : "25%" : "20%"}> 
                <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                >
                    <DatePicker 
                        label="To Date"
                        size="small"
                        format="DD/MM/YYYY"
                        value={tdate}
                        onChange={(newValue) => SetTDate(newValue)}
                        disableFuture
                        sx={{ "& .MuiInputBase-root": { height: 40, display: "flex", alignItems: "center" }, backgroundColor: "#131E2E", marginRight: 1, "& .MuiOutlinedInput-notchedOutline": { border: "none" } }}
                        fullWidth
                    />
                </LocalizationProvider>
            </Grid>
            <Grid width= "15%" marginRight = "10px" > 
                <Button 
                    variant="contained" 
                    size="large" 
                    className={styles.mainbutton}
                    fullWidth
                    onClick={() => handleSubmit()}
                    sx={{height : "40px"}}  
                >Submit</Button> 
            </Grid>
            { !screen800px && <Grid width= { screen900px ? "15%" : "20%"} sx={{display : "block"}}> 
                <Button 
                    variant="outlined"  
                    size="large" 
                    className={styles.outlinedButton}
                     onClick={() => Export_TradeBook(dpdata)} 
                    sx={{textWrap : "nowrap"}}  
                >Download CSV</Button>
            </Grid>}        
            </Grid>
            { screen800px && <Grid width= { screen900px ? "15%" : "20%"} sx={{display : "block"}}> 
                <Button 
                    variant="outlined"  
                    size="large" 
                    className={styles.outlinedButton}
                    onClick={() => Export_TradeBook(dpdata)} 
                    sx={{textWrap : "nowrap"}}  
                >Download CSV</Button>
            </Grid>}

            { error && <Grid sm = {12}><Typography sx={{color : "red", marginTop : "10px"}}>To Date should be greater than From Date </Typography></Grid>}
            <Grid  width="100%" display="flex" justifyContent= "center" flexWrap={screen900px ? "wrap" : "nowrap"} marginTop = "20px">
              {[11,10,9,8,7,6].map((month , index)=>{
                return(
                  <Grid   marginRight={"1%"} width={screen900px ? "30%" : "25%"} >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TradeCalendar
        views={["day"]}
        value={dayjs(tdate).subtract(month,"month")}
        onChange={(newValue)=>handleSelectedDate(newValue)}
        showDaysOutsideCurrentMonth
        disableHighlightToday
        slotProps={{
          day: {
            highlightedDays,
          },
        }}
        slots={{
          day: ServerDay,
        }} 
        sx={{
          background : "transparent",
          height : "185px",
          width : "100%",
          fontSize : "10px" 
        }}
        />
        </LocalizationProvider>
      </Grid>
                )
              })}
      </Grid>
      <Grid width="100%" display="flex" justifyContent= "center" flexWrap={screen900px ? "wrap" : "nowrap"}>
      {[5,4,3,2,1,0].map((month , index)=>{
                return(
                  <Grid   marginRight={"1%"} width={screen900px ? "30%" : "25%"} >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TradeCalendar
        views={["day"]}
        value={dayjs(tdate).subtract(month,"month")}
        onChange={(newValue)=>handleSelectedDate(newValue)}
        showDaysOutsideCurrentMonth
        disableHighlightToday
        slotProps={{
          day: {
            highlightedDays,
          },
        }}
        slots={{
          day: ServerDay,
        }} 
        sx={{
          background : "transparent",
          height : "185px",
          width : "100%",
          fontSize : "10px" 
        }}
        />
        </LocalizationProvider>
      </Grid>
                )
              })}    
      </Grid>
            <TableContainer component={Paper} className={styles.tablecontainer} sx={customScrollbarStyles}>
      
          <Table> 
          <TableHead> 
            <TableRow>
              {dpdata.length!==0 && columns.map((column , index) => (
                <TableCell className={styles.table_h}  key={column.id}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
          {dpdata.length===0 && 
              
              <TableRow  style={{display:'flex',justifyContent:'center'}}>
                 
                      
                          <Alert severity="warning" style={{background:'transparent'}}>No Transactions found !</Alert>
                      
                 
              </TableRow>
          
          }

          {dpdata.length!==0 &&  dpdata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
              <TableRow key={index}>
                {columns.map((column) => (
                  <TableCell 
                  className={styles.table_data}
                  key={column.id}>
           {
                   column.id==="TRADE_TYPE" ?
                  (
                    row[column.id]==="BUY"?
                    <div className={styles.buydiv}>
                      <Typography className={styles.buy} >BUY</Typography>
                    </div>
                    :<div  className={styles.selldiv}>
                    <Typography className={styles.sell} >SELL</Typography>
                  </div>
                  )
                 :
                  <Typography  className={styles.table_data}>
                    {column.id === "PRICE" ? parseFloat(row[column.id]).toFixed(2) : row[column.id]}
                  </Typography>}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        </TableContainer>
        {dpdata.length > 0 && <TablePagination  
              sx={{background : "#0B1420" , width : "100%"}}
              rowsPerPageOptions={[10, 20, 50]}
              rowsPerPage={rowsPerPage}
              page={page}
              count={dpdata.length} 
              component="div"
             onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange} 
              
          />}
        </Grid> 
      </>
    }

<MyModal canShow={showmodal}/>
<MyLodder canShow={showlodder}/>
    </Container>
  );
 
};

export default Tradebook;
